import { ReactionsCommentsQuery } from '../graphql/ReactionsCommentsQuery.graphql';
import { ReactionsContentQuery } from '../graphql/ReactionsContentQuery.graphql';
import type { ReactionsContentQuery as ReactionsContentQueryData } from '../graphql/__types__/ReactionsContentQuery';
import type { ReactionsCommentsQuery as ReactionsCommentsQueryData } from '../graphql/__types__/ReactionsCommentsQuery';
import type { QueryData, ReactionsData } from '../types';

type getReactionsSummaryFn = (data?: QueryData | null) => ReactionsData | null | undefined;

export const getReactionsSummary: getReactionsSummaryFn = (data) => {
	if (!data) {
		return data;
	}

	if (isContentReactions(data)) {
		return (data as ReactionsContentQueryData)?.content?.nodes?.[0]?.contentReactionsSummary;
	}

	if (isCommentReactions(data)) {
		return (data as ReactionsCommentsQueryData)?.comments?.nodes?.[0]?.reactionsSummary;
	}
};

const isContentReactions = (data: QueryData): data is ReactionsContentQueryData =>
	Boolean((data as ReactionsContentQueryData).content);

const isCommentReactions = (data: QueryData): data is ReactionsCommentsQueryData =>
	Boolean((data as ReactionsCommentsQueryData).comments);

export const getReactionsQueryInfo = (isComment, contentId, containerId) => {
	const query = isComment ? ReactionsCommentsQuery : ReactionsContentQuery;
	const queryVariables = isComment ? { contentId, containerId } : { contentId };

	return { query, queryVariables };
};
